import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useSpaData } from "../context/SpaDataContext";
import { useBooking } from "../context/BookingContext";
import { imgUrl } from "../lib/spa";

export const TherapistCard = ({ therapist }) => {
  const { t, ml } = useLanguage();
  const { massages } = useSpaData();
  const { openBooking } = useBooking();

  const specialtyNames = therapist.massages
    .map((slug) => massages.find((m) => m.slug === slug))
    .filter(Boolean)
    .slice(0, 3)
    .map((m) => ml(m.name).replace(/^(Massagem|Massage|Masaje)\s+/i, ""));

  return (
    <div
      data-testid={`therapist-card-${therapist.slug}`}
      className="group relative overflow-hidden rounded-2xl border border-foreground/8 bg-card"
    >
      <Link to={`/terapeutas/${therapist.slug}`} className="block">
        <div className="aspect-[3/4] overflow-hidden">
          <img
            src={imgUrl(therapist.profile)}
            alt={therapist.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        </div>
        {therapist.available_today && (
          <span
            data-testid={`therapist-available-badge-${therapist.slug}`}
            className="absolute left-3 top-3 z-10 flex items-center gap-1.5 rounded-full bg-gold px-3 py-1.5 text-[9px] font-bold uppercase tracking-[0.18em] text-black shadow-lg shadow-black/30"
          >
            <span className="relative flex h-1.5 w-1.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-black/50" />
              <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-black" />
            </span>
            {t("team.availableToday")}
          </span>
        )}
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-90" />
        <div className="absolute inset-x-0 bottom-0 p-4 pr-24 sm:p-5 sm:pr-28">
          <h3 className="font-display text-xl font-medium text-white sm:text-2xl">{therapist.name}</h3>
          <p className="mt-1 line-clamp-1 text-xs tracking-wide text-white/60">
            {specialtyNames.join(" • ")}
          </p>
        </div>
        <span className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full border border-white/20 bg-black/40 text-white opacity-0 backdrop-blur-sm transition-all duration-300 group-hover:opacity-100">
          <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
        </span>
      </Link>
      <button
        data-testid={`therapist-card-book-${therapist.slug}`}
        onClick={() => openBooking({ therapistSlug: therapist.slug })}
        className="absolute bottom-4 right-4 rounded-full border border-gold/50 bg-black/50 px-3 py-2 text-[10px] font-medium uppercase tracking-[0.2em] text-gold backdrop-blur-sm transition-all duration-300 hover:bg-gold hover:text-black sm:bottom-5 sm:right-5 sm:px-4"
      >
        {t("nav.book")}
      </button>
    </div>
  );
};
